//imports
import React,{useState} from 'react';
import { Pill } from 'Components';
import Checkbox from 'Components/Checkbox';
import Input from 'Components/Input';
import { Grid } from '@mui/material';
import styles from "Assets/sass/core/vars.scss";
import { Select, Form } from 'Components';
import InputDate from 'Components/InputDate';
import CustomTimeRange from 'Components/uiControls/CustomTimeRange';



//This import is necessary to use the ref in the InputDate function component
const NewInputDateRef = React.forwardRef((props, ref) => <InputDate innerRef={ref} {...props} />);
const FrequencyStep = ({ setStateCustomTimeRange,validateCustomTimeRanges ,frequencyOptions, daysOptions, onChangeFrequency, onChangeSelectDay, onChangeDeliverOn, frequency, daysIncluded, deliverOn, messages, inputDeliverAt, deliveryOnList, onChangeReportType, selectOptions, handleNext, errorIncludeDates, errorDeliverOn, deliveredOnMonthly, onChangeDeliverOnMonthly, errorDeliveryAt, errorDeliveryOnMonthly, onChangeDeliveryAt,scheduleTimeRanges }) => {

  return (
    <Form ref={selectOptions} onSubmit={handleNext}>
      <div className="schedule-report-frequency-container">
        <hr></hr>
        <div className="schedule-report-day-label">
          <label>{messages['reportsMainST_scheduleFrequencyMessage']}</label>
        </div>
        <Grid container spacing={1}>
          {frequencyOptions.map((item) => (
            <Grid item sm={4} className="schedule-report-frequency-item" key={item.id}>
              <Pill
                style={{ width: '100%' }}
                item={{ name: item.label, color: styles.green }}
                colorField='default'
                colorSelection="#005bf8"
                className={`schedule-report-frequency-item-pill`}
                outlined={item.id !== frequency}
                onClick={() => onChangeFrequency(item.id)}

              />
              <span>{item.description}</span>
            </Grid>
          ))}
        </Grid>

        <CustomTimeRange
              scheduleTimeRanges={scheduleTimeRanges}
              setStateCustomTimeRange={setStateCustomTimeRange}
              validateCustomTimeRanges={validateCustomTimeRanges}
              errorMessage={messages["reportsMainST_selectAtLeastOneDay"]}
        />
        {
          frequency === 'weekly' &&
          (
            <>
              <DaysComponent
                daysOptions={daysOptions}
                selectedDays={deliverOn}
                onChangeSelectDay={onChangeDeliverOn}
                label={messages['reportsMainST_deliverOn']}
                classNameCheckbox={`schedule-report-frequency-deliveron-checkbox`}
                error={errorDeliverOn}
                errorMessage={messages['reportsMainST_errorNotDay']}
              />
            </>
          )
        }
        {
          frequency === 'monthly' &&
          (
            <div style={{ marginTop: '10px' }}>
              {errorDeliveryOnMonthly && <span className="schedule-report-error">{messages['reportsMainST_deliveryOnRequired']}</span>}
              <Select
                id="deliveredOn"
                label={messages['reportsMainST_deliverOn']}
                value={deliveredOnMonthly}
                onChange={onChangeDeliverOnMonthly}
                options={deliveryOnList}
                textField="label"
                valueField="id"
                required
                placeholder={messages['select']}
              />
            </div>
          )
        }
        <div style={{ marginTop: '10px' }}>
          {errorDeliveryAt && <span className="schedule-report-error">{messages['reportsMainST_deliveryAtRequired']}</span>}
          <NewInputDateRef
            {...inputDeliverAt}
            onChange={onChangeDeliveryAt}
            id={'input-date-range'}
            type={'time'}
            className={'input-date-range-veh-drivers'}
            onClose={() => { }}
            required
            requiredMessage={messages['required_field']}
          />
        </div>
      </div>
    </Form>
  );
}


const DaysComponent = ({ daysOptions, selectedDays, onChangeSelectDay, label, classNameCheckbox, error, errorMessage }) => {

  return (

    <div className="schedule-report-day-container">
      {error && <span className="schedule-report-error">{errorMessage}</span>}
      <div className="schedule-report-day-label">
        <label>{label}</label>
      </div>
      <Grid container spacing={1} className={classNameCheckbox}>
        {daysOptions.map((day, index) => (

          <Grid item key={day.key}>
            <label className="app-radio-button" key={index}>
              <input
                type='checkbox'
                name='type'
                value={day.id}
                checked={!!selectedDays.find(selectedDay => selectedDay === day.id)}
                onChange={onChangeSelectDay}
              />
              <div className='app-radio-button-box'>
                <span className='app-radio-button-box-type pt-2'>{day.label}</span>
              </div>
            </label>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
FrequencyStep.defaultProps = {
  daysIncluded: [],
  deliverOn: []
}

export default FrequencyStep;
